<template>
  <div class="schlafworkshop">
    <h1>Schlafworkshop</h1>
    <p>Du willst den Schlaf deines Babys besser verstehen oder bist erschöpft von den vielen schlaflosen Nächten? Du bist schwanger und möchtest dich vorab informieren, ob beim Schlafen von Babys tatsächlich feste Zeiten eingehalten werden sollten? Du hast gehört, dass Babys auch mal Schreien gelassen werden sollten, aber in dir sträubt es sich dagegen?</p>
    <p>In meinem Workshop zum Baby- & Kleinkindschlaf erkläre ich euch die Hintergründe zum Thema Schlaf und worauf es bei unseren Kleinsten wirklich ankommt. Kein Kind muss schlafen lernen indem es schreiend allein gelassen wird. Denn jedes Kind kann schlafen.</p>
    <p>Wenn ihr auf der Suche nach Antworten auf diese und weitere Fragen seid, dann seid ihr in meinem Kurs genau richtig.</p>
    <p>Am Ende bleibt selbstverständlich noch Zeit für eure Fragen. Der Schlaf unserer Kinder ist jedoch so individuell wie sie selbst. Bitte habt deshalb Verständnis, dass eine individuelle <router-link to="/schlafberatung">Schlafberatung</router-link> aufgrund der begrenzten Zeit nicht möglich ist.</p>
  </div>
</template>

<script>
export default {
  name: 'Schlafworkshop'
}
</script>

<style scoped>
.schlafworkshop {
}
</style>